import type { User } from "./types";

/**
 * The only two accounts that can sign in. There is no registration.
 *
 * CHANGE THESE before you share the site. Pick real passwords.
 *
 * Note: this is client-side auth, fine for a private showcase but not a
 * security boundary. Anyone determined can read the bundle. If the gallery
 * ever needs to gate truly private data, move auth to a real backend.
 */
interface Account extends User {
  password: string;
}

export const ACCOUNTS: Account[] = [
  { username: "tracy", password: "changeme", name: "Tracy" },
  { username: "josh", password: "changeme", name: "Josh" },
];

/** Where "Inquire" buttons send collectors. Set to TL's email. */
export const INQUIRY_EMAIL = "hello@tlart.example";

/** Public Instagram profile URL shown in nav/footer/about. */
export const INSTAGRAM_URL = "https://instagram.com/tlart2023";

export function findAccount(username: string, password: string): User | null {
  const u = username.trim().toLowerCase();
  const match = ACCOUNTS.find(
    (a) => a.username === u && a.password === password,
  );
  return match ? { username: match.username, name: match.name } : null;
}
